/**
 * F47: a suggestion of the language model in "Do zatwierdzenia" — the badge "Podpowiedź modelu" and the model's
 * one-sentence reason. Always to be checked by a person (never booked by itself); a suggestion of the rules: nothing.
 */
export function ModelHint({ reason, source = 'model' }: { reason: string; source?: 'reguly' | 'model' }) {
  if (source !== 'model') return null;
  return (
    <span className="pay-sub">
      <span className="pay-model-badge" title="Propozycja modelu językowego — sprawdź przed zatwierdzeniem">
        Podpowiedź modelu
      </span>{' '}
      <span>{reason}</span>
    </span>
  );
}
